import { type Kpi } from "@features/mmm/components/explore-budgets/client-setting/types";
import { useNorthbeamLazyQuery } from "@hooks/http";
import {
  type FetchKPIs,
  type FetchKPIsVariables,
} from "@north-beam/nb-client-side/nb-api-graphql-generated";

import { MMM_KPI_DATA_QUERY } from "../explore-budgets-v2/explore-budgets-queries";

import { useClientKpis } from "./use-client-kpis";

export const useAvailableKpis = () => {
  const { setClientKpis } = useClientKpis();

  const {
    loadData: loadKpis,
    data: { loading: isLoadingKpis },
  } = useNorthbeamLazyQuery<FetchKPIs, FetchKPIsVariables>(MMM_KPI_DATA_QUERY, {
    onCompleted: (data) => {
      const { availableKpis } = data.me.mmm;

      if (availableKpis.modelKpis.length > 0) {
        setClientKpis(availableKpis.modelKpis as unknown as Kpi[]);
        return;
      }

      setClientKpis(availableKpis.cycleKpis as unknown as Kpi[]);
    },
  });

  return { loadKpis, isLoadingKpis };
};
